// extracted by mini-css-extract-plugin
export default {"disabledField":"Table_disabledField__oRe5n"};